import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SR_API_ACTION_GET_LISTING_LIST } from 'api/actionTypes';
import { SCREEN_ID_BROKER_LISTINGS_IFRAME_VIEW } from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withScreenId from 'client/helpers/withScreenId';
import withApiState from 'client/helpers/withApiState';

import postWithState from 'client/actions/postWithState';
import ListingCard from 'client/components/ListingCard';

@withScreenId(SCREEN_ID_BROKER_LISTINGS_IFRAME_VIEW)
@withApiState({
  listingsApiState: {
    action: SR_API_ACTION_GET_LISTING_LIST,
  },
})
@branch({
  currentUser: ['currentUser'],
  listingPhotoResolution: ['listingPhotoResolution'],
})
class BrokerListingsWidget extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Rentals',
  })

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    listingPhotoResolution: PropTypes.number.isRequired,
    listingsApiState: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      listings: null,
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    if (match.params.listingManagementCompany) {
      dispatch(postWithState, {
        action: SR_API_ACTION_GET_LISTING_LIST,
        payload: {
          page: 0,
          count: 150,
          filters: {
            listingManagementCompany: match.params.listingManagementCompany,
          },
        },
      })
        .then((queryResult) => {
          this.setState({ listings: queryResult.data });
        });
    }
  }

  render() {
    const {
      match,
      currentUser,
      listingPhotoResolution,
      listingsApiState,
    } = this.props;

    const {
      listings,
    } = this.state;

    return (
      <div className='page-listings-widget'>
        <div className='listView'>
          {!match.params.listingManagementCompany && (
            <div>Missing listing management company in iframe URL.</div>
          )}
          {listings && (
            <div className='resultsContainer clearfix'>
              {listings.map((listing) => (
                <ListingCard
                  key={listing.id}
                  listing={listing}
                  currentUser={currentUser}
                  photoResolution={listingPhotoResolution}
                  enableBookmarksButton={false}
                  showRequestShowingButton={false}
                  showThumbnailListingAddress
                  disablePhotoCarousel
                  managementCompanyIframe={match.params.listingManagementCompany}
                />
              ))}
            </div>
          )}
          {listingsApiState.inProgress && (
            <div className='loading-gif clearfix' />
          )}
        </div>
      </div>
    );
  }
}

BrokerListingsWidget.displayName = 'BrokerListingsWidget';

export default BrokerListingsWidget;
